import CouponListContainer from './CouponListContainer';
export default CouponListContainer;
